import { render, staticRenderFns } from "./addressData.vue?vue&type=template&id=84b9b754&scoped=true&"
import script from "./addressData.vue?vue&type=script&lang=js&"
export * from "./addressData.vue?vue&type=script&lang=js&"
import style0 from "./addressData.vue?vue&type=style&index=0&id=84b9b754&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b9b754",
  null
  
)

export default component.exports